import {getDsContext} from "@/utils/dsContext";
import ImportCompetitionData from "@/pages/Settings/CompetitionSeasons/ImportCompetitionData";
import React, {useEffect, useState} from "react";
import {
	Routes,
	Route,
	useLocation,
	Navigate,
	useNavigate,
} from "react-router-dom";
import {useDispatch, useSelector} from "react-redux";

import Loading from "@/components/Loading";
import Snackbar from "@mui/material/Snackbar";
import Alert from "@mui/material/Alert";
import SideMenu from "@/components/SideMenu";
import ChatFAB from "@/components/ChatFAB";
import {DsBottomNav} from "@/components/DsKit";

import AthleticTestsPage from "@/pages/Manager/AthleticTests";
import AthleticTestPage from "@/pages/Manager/AthleticTest";
import HandleSettingsSeasonPage from "@/pages/Settings/Seasons/HandleSeason";
import VenuesPage from "@/pages/Settings/Venues";
import SettingsSeasonsPage from "@/pages/Settings/Seasons";
import SettingsCategoriesPage from "@/pages/Settings/Categories";
import CompetitionsPage from "@/pages/Settings/Competitions";
import HandleCompetitionPage from "@/pages/Settings/Competitions/HandleCompetition";
import CompetitionSeasonsPage from "@/pages/Settings/CompetitionSeasons";
import CompetitionSeasonPage from "@/pages/Settings/CompetitionSeasons/CompetitionSeason";
import HandleCompetitionSeasonPage from "@/pages/Settings/CompetitionSeasons/HandleCompetitionSeason";
import ClubsPage from "@/pages/Clubs";
import ClubPage from "@/pages/Clubs/Club";
import ExercisePage from "@/pages/Exercises/Exercise";
import ExercisesPage from "@/pages/Exercises";
import HandleAthleticTestPage from "@/pages/Manager/HandleAthleticTest";
import HandleClubPage from "@/pages/HandleClub";
import HandleExercisePage from "@/pages/Exercises/HandleExercise";
import HandleMatchPage from "@/pages/Manager/HandleMatch";
import HandleMatchReportPage from "@/pages/MatchReports/HandleMatchReport";
import HandleMedicalInjuryPage from "@/pages/Medical/HandleInjury";
import HandlePlayerPage from "@/pages/HandlePlayer";
import HandleRosterPage from "@/pages/Rosters/Modals/handleRoster";
import HandleScoutingStaffPage from "@/pages/Scouting/Staffs/HandleStaff";
import HandleScoutingMatchPage from "@/pages/Scouting/Matches/HandleMatch";
import HandleScoutingPlayerPage from "@/pages/Scouting/Players/HandlePlayer";
import HandleScoutingReportPage from "@/pages/Scouting/ScoutReports/HandleScoutReport";
import HandleSettingsCategoryPage from "@/pages/Settings/Categories/HandleCategory";
import ManagerHandleStaffPage from "@/pages/HandleStaff";
import HandleStaffRolePage from "@/pages/Settings/HandleStaffRole";
import HandleStaffUnitPage from "@/pages/Settings/HandleStaffUnit";
import HandleTQRPage from "@/pages/HandleTQR";
import HandleTrainingPage from "@/pages/Manager/HandleTraining";
import HandleUserPage from "@/pages/Settings/HandleUser";
import HandleUserRolePage from "@/pages/Settings/HandleUserRole";
import HandleValuationPage from "@/pages/Valuations/HandleValuation";
import HandleVideoPage from "@/pages/HandleVideo";
import MedicalInjuryPage from "@/pages/Medical/Injury";
import LoginPage from "@/pages/Login";
import DsHomePage from "@/pages/DirectorDS/Home";
import DsActivitiesPage from "@/pages/DirectorDS/Activities";
import DsTimelinePage from "@/pages/DirectorDS/Timeline";
import DsTeamsPage from "@/pages/DirectorDS/Teams";
import DsTeamManagerPage from "@/pages/DirectorDS/TeamManager";
import DsPlayerPage from "@/pages/DirectorDS/Player";
import DsTeamPage from "@/pages/DirectorDS/Team";
import DsMatchPage from "@/pages/DirectorDS/Match";

import DsMatchesPage from "@/pages/DirectorDS/Matches";
import DsPerformancePage from "@/pages/DirectorDS/Performance";
import DsMedicalPage from "@/pages/DirectorDS/Medical";
import DsMarketPage from "@/pages/DirectorDS/Market";
import DsAgentsPage from "@/pages/DirectorDS/Agents";
import DsScoutingPage from "@/pages/DirectorDS/Scouting";
import DsStaffPage from "@/pages/DirectorDS/Staff";
import DsSecretariatPage from "@/pages/DirectorDS/Secretariat";
import DsEconomyPage from "@/pages/DirectorDS/Economy";
import DsFacilitiesPage from "@/pages/DirectorDS/Facilities";
import DsCommercialPage from "@/pages/DirectorDS/Commercial";
import SecretariatPage from "@/pages/Secretariat";
import MatchDayPage from "@/pages/MatchDay";
import ImportDataPage from "@/pages/ImportData";
import HandleSmartValuationPage from "@/pages/Valuations/HandleSmartValuation";
import ManagerHandleFootballTeamPage from "@/pages/Manager/FootballTeams/HandleFootballTeam";
import ManagerFootballTeamPage from "@/pages/Manager/FootballTeams/FootballTeam";
import ManagerFootballTeamsPage from "@/pages/Manager/FootballTeams";
import ManagerPlayersPage from "@/pages/Players";
import PlayersComparisonPage from "@/pages/Players/Comparison";
import MatchPage from "@/pages/Manager/Match";
import MatchesPage from "@/pages/Matches";
import EventsCalendarPage from "@/pages/EventsCalendar";
import MatchReportPage from "@/pages/MatchReports/MatchReport";
import MatchReportsPage from "@/pages/MatchReports";
import MedicalOverviewPage from "@/pages/Medical/Overview";
import MedicalRecordPage from "@/pages/Medical/Record";
import MedicalRecordsPage from "@/pages/Medical/Records";
import PlayerPage from "@/pages/Player";
import PlayerProfilePage from "@/pages/PlayerProfile";
import RPEPage from "@/pages/RPE";
import WellnessPage from "@/pages/Measurations/Wellness";
import GPSSessionsPage from "@/pages/GPS";
import GPSImportPage from "@/pages/GPS/Import";
import GPSSessionPage from "@/pages/GPS/Session";
import ScoutingRosterPage from "@/pages/Rosters/Roster";
import ScoutingRostersPage from "@/pages/Rosters";
import ScoutingStaffPage from "@/pages/Scouting/Staffs/Staff";
import ScoutingStaffsPage from "@/pages/Scouting/Staffs";
import ScoutingMatchPage from "@/pages/Scouting/Matches/Match";
import ScoutingMatchesPage from "@/pages/Scouting/Matches";
import ScoutingDatabasePage from "@/pages/Scouting/Players";
import ScoutingPlayerPage from "@/pages/Scouting/Players/Player";
import ScoutingPipelinePage from "@/pages/Scouting/Pipeline";
import ScoutingReportPage from "@/pages/Scouting/ScoutReports/ScoutReport";
import ScoutingReportsPage from "@/pages/Scouting/ScoutReports";
import RelazioniPage from "@/pages/Scouting/Relazioni";
import RelazionePage from "@/pages/Scouting/Relazioni/Relazione";
import HandleRelazionePage from "@/pages/Scouting/Relazioni/HandleRelazione";
import RelazioniTemplatesPage from "@/pages/Scouting/Relazioni/Templates";
import ScoutingIndicesPage from "@/pages/Scouting/Indici";
import ScoutValuationPage from "@/pages/Valuations/ScoutValuation";
import ManagerStaffPage from "@/pages/Staff";
import ManagerStaffsPage from "@/pages/Staffs";
import StaffRolePage from "@/pages/Settings/StaffRole";
import StaffRolesPage from "@/pages/Settings/StaffRoles";
import StaffUnitPage from "@/pages/Settings/StaffUnit";
import StaffUnitsPage from "@/pages/Settings/StaffUnits";
import SettingsPlayerRolePage from "@/pages/Settings/PlayerRole";
import SettingsPlayerRolesPage from "@/pages/Settings/PlayerRoles";
import SettingsComponentsPage from "@/pages/Settings/Components";
import NotFoundPage from "@/pages/NotFound";
import HandleSettingsPlayerRolePage from "@/pages/Settings/HandlePlayerRole";
import SettingsModulePage from "@/pages/Settings/Module";
import SettingsModulesPage from "@/pages/Settings/Modules";
import HandleSettingsModulePage from "@/pages/Settings/HandleModule";
import ContractsPage from "@/pages/Contracts";
import ContractPage from "@/pages/Contract";
import HandleContractPage from "@/pages/HandleContract";
import FinancePage from "@/pages/Finance";
import MarketSimulationPage from "@/pages/Manager/MarketSimulation";
import TQRPage from "@/pages/TQR";
import TrainingPage from "@/pages/Manager/Training";
import TrainingsPage from "@/pages/Manager/Trainings";
import UserRolePage from "@/pages/Settings/UserRole";
import UserRolesPage from "@/pages/Settings/UserRoles";
import UserPage from "@/pages/Settings/User";
import UsersPage from "@/pages/Settings/Users";
import ValuationPage from "@/pages/Valuations/Valuation";
import ValuationsPage from "@/pages/Valuations";
import PublicValuationPage from "@/pages/Valuations/PublicValuation";
import PublicPlayerPage from "@/pages/PublicPlayer";
import VASPage from "@/pages/VAS";
import VideoPage from "@/pages/Video";
import MessagesPage from "@/pages/Messages";
import AccountPage from "@/pages/Account";
import VideosPage from "@/pages/Videos";

import {AuthorizationAPI} from "@/api/authorization";
import {SeasonAPI} from "@/api/season";

import {
	loginSuccess,
	logout,
	setSelectedMenuItem as setGeneralSelectedMenuItem,
	userSuccess,
} from "@/actions";

import {theme} from "@/style/utils.js";
import {ThemeProvider} from "@mui/material/styles";

import {ERROR_OPERATION} from "@/utils/constants";
import {canOpenPath, homePath, isPlayer} from "@/utils/access";
import {orderByDate} from "@/utils/functions";

import "@/style/App.scss";

const documentHeight = () => {
	const doc = document.documentElement;
	doc.style.setProperty("--doc-height", `${window.innerHeight}px`);
};

function Layout({children}) {
	const dispatch = useDispatch();

	const selectedMenuItem = useSelector((state) => state?.selectedMenuItem);
	const user = useSelector((state) => state?.user);
	const userRole = user?.roleName;

	const location = useLocation();

	// Vista attiva: giocatore, vista essenziale DS (resta tale nelle pagine
	// aperte da lì, finché non si sceglie una voce del menu completo) o club.
	useEffect(() => {
		if (!userRole) return;
		const next = isPlayer(user)
			? "player"
			: location.pathname.startsWith("/ds") || selectedMenuItem === "ds"
				? "ds"
				: "club";
		if (next !== selectedMenuItem) dispatch(setGeneralSelectedMenuItem(next));
	}, [userRole, location.pathname]); // eslint-disable-line react-hooks/exhaustive-deps

	if (!userRole || !selectedMenuItem) {
		return <Loading visible />;
	}

	return (
		<div
			className={
				"layout-container layout-no-header" +
				(selectedMenuItem === "ds" ? " layout-ds" : "")
			}
		>
			<div className="layout">
				<div className="layout-side">
					<div className="d-flex" style={{height: "100%"}}>
						<SideMenu />
						{children}
					</div>
				</div>
			</div>
			<ChatFAB />
			{selectedMenuItem === "ds" && <DsBottomNav />}
		</div>
	);
}

// Maintenance tool: excluded from ordinary and production builds.
const ScoutingRecoveryPage =
	process.env.REACT_APP_ENV === "test"
		? React.lazy(() => import("@/pages/Scouting/Recovery"))
		: null;

function RequireAuth({isLoggedIn, handleNotification, children}) {
	let location = useLocation();
	const user = useSelector((state) => state?.user);

	if (!isLoggedIn) {
		return <Navigate to="/login" state={{from: location}} replace />;
	}

	// Rotte protette per area: senza permesso si torna alla propria home
	if (user?.roleName && !canOpenPath(user, location.pathname)) {
		return <Navigate to="/" replace />;
	}

	const childWithProps = React.Children.only(children);

	return (
		<ThemeProvider theme={theme}>
			<Layout>
				{React.cloneElement(childWithProps, {handleNotification})}
			</Layout>
		</ThemeProvider>
	);
}

function App() {
	const dsContext = useSelector(getDsContext);
	const dsLocation = useLocation();
	const dispatch = useDispatch();
	const navigate = useNavigate();

	const isLoggedIn = useSelector((state) => state.isLoggedIn);
	const userRole = useSelector((state) => state?.user?.roleName);

	const [loading, setLoading] = useState(true);
	const [open, setOpen] = useState(false);
	const [message, setMessage] = useState("");
	const [severity, setSeverity] = useState("info");

	const handleClose = () => {
		setOpen(false);
	};

	const handleNotification = (newMessage, newSeverity = "info") => {
		setMessage(newMessage);
		setSeverity(newSeverity);
		setOpen(true);
	};

	useEffect(() => {
		if (isLoggedIn) {
			const getUserData = async () => {
				try {
					const [response, seasons] = await Promise.all([
						AuthorizationAPI.getUserData(),
						SeasonAPI.allSeasons(),
					]);
					const storedSeasonId = localStorage.getItem("seasonId");
					const sortedSeasons = orderByDate(seasons, "startDate");
					const selectedSeason =
						sortedSeasons.find((s) => s.id === storedSeasonId || s.current) ||
						sortedSeasons[sortedSeasons.length - 1];

					dispatch(
						userSuccess({
							user: response,
							season: selectedSeason,
							seasons: sortedSeasons,
						}),
					);
				} catch (error) {
					handleNotification(ERROR_OPERATION, "error");
					dispatch(logout());
					navigate("/login");
				}
			};

			getUserData();
		}
	}, [dispatch, isLoggedIn]);

	useEffect(() => {
		window.addEventListener("resize", documentHeight);
		documentHeight();

		const checkToken = async (token) => {
			try {
				await AuthorizationAPI.verifyToken(token);
				dispatch(loginSuccess(token));
			} catch (error) {
				dispatch(logout());
			} finally {
				setLoading(false);
			}
		};

		const savedToken = localStorage.getItem("token");
		if (savedToken) {
			setLoading(true);
			checkToken(savedToken);
		} else {
			setLoading(false);
		}
	}, [dispatch]);

	const user = useSelector((state) => state?.user);
	const homeTarget = homePath(user);

	// Gare e allenamenti dello staff stanno nel calendario unico; il giocatore tiene le sue liste.
	const playerListOrCalendar = (page) =>
		userRole === "Player" ? page : <Navigate to="/calendar" replace />;

	const authRoutes = [
		{component: <Navigate to={homeTarget} replace />, path: "/"},
		{component: <ManagerStaffsPage />, path: "/manager/staffs"},
		{component: <ManagerStaffPage />, path: "/manager/staffs/:id"},
		{component: <ManagerHandleStaffPage />, path: "/manager/staffs/new"},
		{
			component: <ManagerHandleStaffPage edit />,
			path: "/manager/staffs/:id/edit",
		},
		{component: <ManagerPlayersPage />, path: "/players"},
		{component: <PlayersComparisonPage />, path: "/manager/players-comparison"},
		{component: <PlayerPage />, path: "/players/:id"},
		{component: <HandlePlayerPage />, path: "/players/new"},
		{component: <HandlePlayerPage edit />, path: "/players/:id/edit"},
		{component: <ContractsPage />, path: "/manager/players-contracts"},
		{component: <ContractPage />, path: "/manager/players-contracts/:id"},
		{component: <HandleContractPage />, path: "/manager/players-contracts/new"},
		{
			component: <HandleContractPage edit />,
			path: "/manager/players-contracts/:id/edit",
		},
		{component: <FinancePage />, path: "/manager/finance"},
		{component: <MarketSimulationPage />, path: "/manager/market-simulation"},
		{component: <ValuationPage />, path: "/players-valuations/:id"},
		{component: <HandleValuationPage />, path: "/players-valuations/new"},
		{
			component: <HandleValuationPage edit />,
			path: "/players-valuations/:id/edit",
		},
		{
			component: <HandleSmartValuationPage />,
			path: "/players-valuations/smart/new",
		},
		{
			component: <HandleSmartValuationPage edit />,
			path: "/players-valuations/smart/:id/edit",
		},
		{
			component: <ValuationsPage external />,
			path: "/scouting/valuations",
		},
		{component: <ValuationPage external />, path: "/scouting/valuations/:id"},
		{
			component: <ScoutValuationPage external />,
			path: "/scouting/scout-valuations/:id",
		},
		{
			component: <HandleValuationPage external />,
			path: "/scouting/valuations/new",
		},
		{
			component: <HandleValuationPage edit external />,
			path: "/scouting/valuations/:id/edit",
		},

		{component: <VenuesPage />, path: "/settings/venues"},
		{component: <SettingsSeasonsPage />, path: "/settings/seasons"},
		{component: <HandleSettingsSeasonPage />, path: "/settings/seasons/new"},
		{
			component: <HandleSettingsSeasonPage edit />,
			path: "/settings/seasons/:id/edit",
		},
		{component: <SettingsCategoriesPage />, path: "/settings/categories"},
		{
			component: <HandleSettingsCategoryPage />,
			path: "/settings/categories/new",
		},
		{
			component: <HandleSettingsCategoryPage edit />,
			path: "/settings/categories/:id/edit",
		},
		{component: <CompetitionsPage />, path: "/settings/competitions"},
		{
			component: <HandleCompetitionPage />,
			path: "/settings/competitions/new",
		},
		{
			component: <HandleCompetitionPage edit />,
			path: "/settings/competitions/:id/edit",
		},
		{component: <CompetitionSeasonsPage />, path: "/competitions"},
		{component: <CompetitionSeasonPage />, path: "/competitions/:id"},
		{
			component: <HandleCompetitionSeasonPage />,
			path: "/settings/competition-seasons/new",
		},
		{
			component: <HandleCompetitionSeasonPage edit />,
			path: "/settings/competition-seasons/:id/edit",
		},
		{
			component: <ImportCompetitionData />,
			path: "/settings/competition-seasons/import",
		},
		{component: <ClubsPage />, path: "/settings/clubs"},
		{component: <ClubPage />, path: "/settings/clubs/:id"},
		{component: <HandleClubPage />, path: "/settings/clubs/new"},
		{
			component: <HandleClubPage edit />,
			path: "/settings/clubs/:id/edit",
		},
		...["/trainings"].map((path) => ({
			path,
			component: playerListOrCalendar(<TrainingsPage />),
		})),
		...["/trainings/:id"].map((path) => ({
			path,
			component: <TrainingPage />,
		})),
		...["/trainings/new"].map((path) => ({
			path,
			component: <HandleTrainingPage />,
		})),
		...["/trainings/:id/edit"].map((path) => ({
			path,
			component: <HandleTrainingPage edit />,
		})),
		...["/matches"].map((path) => ({
			path,
			component: playerListOrCalendar(<MatchesPage />),
		})),
		{path: "/calendar", component: <EventsCalendarPage />},
		...["/matches/:id"].map((path) => ({
			path,
			component: <MatchPage />,
		})),
		...["/matches/new"].map((path) => ({
			path,
			component: <HandleMatchPage />,
		})),
		...["/matches/:id/edit"].map((path) => ({
			path,
			component: <HandleMatchPage edit />,
		})),
		...["/match-reports"].map((path) => ({
			path,
			component: <MatchReportsPage fullpage />,
		})),
		...["/match-reports/new"].map((path) => ({
			path,
			component: <HandleMatchReportPage />,
		})),
		...["/match-reports/:id"].map((path) => ({
			path,
			component: <MatchReportPage />,
		})),
		...["/match-reports/:id/edit"].map((path) => ({
			path,
			component: <HandleMatchReportPage edit />,
		})),
		{component: <TQRPage />, path: "/measurations/tqr"},
		{component: <RPEPage />, path: "/measurations/rpe"},
		{component: <VASPage />, path: "/measurations/vas"},
		{component: <WellnessPage />, path: "/measurations/wellness"},
		{component: <HandleTQRPage />, path: "/measurations/tqr/new"},
		{component: <GPSSessionsPage />, path: "/gps"},
		{component: <GPSImportPage />, path: "/gps/import"},
		{component: <GPSSessionPage />, path: "/gps/:id"},
		{component: <AccountPage />, path: "/account"},
		{component: <MessagesPage />, path: "/messages"},
		{component: <MessagesPage />, path: "/messages/:conversationId"},
		{component: <AthleticTestsPage />, path: "/athletic-tests"},
		{component: <AthleticTestPage />, path: "/athletic-tests/:id"},
		{component: <HandleAthleticTestPage />, path: "/athletic-tests/new"},
		{
			component: <HandleAthleticTestPage edit />,
			path: "/athletic-tests/:id/edit",
		},
		{component: <VideosPage />, path: "/video"},
		{component: <VideoPage />, path: "/video/:id"},
		{component: <HandleVideoPage />, path: "/video/new"},
		{component: <HandleVideoPage edit />, path: "/video/:id/edit"},
		{component: <MedicalOverviewPage />, path: "/medical/overview"},
		{component: <MedicalRecordsPage />, path: "/medical/records"},
		{component: <MedicalRecordPage />, path: "/medical/records/:id"},
		{
			component: <MedicalInjuryPage />,
			path: "/medical/records/:recordId/injuries/:id",
		},
		{
			component: <HandleMedicalInjuryPage />,
			path: "/medical/records/:id/injuries/new",
		},
		{
			component: <HandleMedicalInjuryPage edit />,
			path: "/medical/records/:id/injuries/:injuryId/edit",
		},
		{component: <ScoutingPipelinePage />, path: "/scouting/pipeline"},
		{component: <ScoutingIndicesPage />, path: "/scouting/indici"},
		...(ScoutingRecoveryPage
			? [
					{
						component: (
							<React.Suspense fallback={<Loading visible />}>
								<ScoutingRecoveryPage />
							</React.Suspense>
						),
						path: "/scouting/recupero",
					},
				]
			: []),
		{component: <RelazioniPage />, path: "/scouting/relazioni"},
		{component: <HandleRelazionePage />, path: "/scouting/relazioni/new"},
		{
			component: <RelazioniTemplatesPage />,
			path: "/scouting/relazioni/templates",
		},
		{component: <RelazionePage />, path: "/scouting/relazioni/:id"},
		{
			component: <HandleRelazionePage edit />,
			path: "/scouting/relazioni/:id/edit",
		},
		{component: <ScoutingReportsPage />, path: "/scouting/reports"},
		{component: <ScoutingReportPage />, path: "/scouting/reports/:id"},
		{component: <HandleScoutingReportPage />, path: "/scouting/reports/new"},
		{
			component: <HandleScoutingReportPage edit />,
			path: "/scouting/reports/:id/edit",
		},
		{component: <ScoutingMatchesPage />, path: "/scouting/planning"},
		{component: <ScoutingMatchPage />, path: "/scouting/planning/:id"},
		{
			component: <HandleScoutingMatchPage edit />,
			path: "/scouting/planning/:id/edit",
		},
		{component: <HandleScoutingMatchPage />, path: "/scouting/planning/new"},
		{component: <ScoutingStaffsPage />, path: "/scouting/staffs"},
		{component: <ScoutingStaffPage />, path: "/scouting/staffs/:id"},
		{
			component: <HandleScoutingStaffPage edit />,
			path: "/scouting/staffs/:id/edit",
		},
		{component: <HandleScoutingStaffPage />, path: "/scouting/staffs/new"},
		{component: <ScoutingDatabasePage />, path: "/scouting/players"},
		{component: <ScoutingPlayerPage />, path: "/scouting/players/:id"},
		{
			component: <HandleScoutingPlayerPage edit />,
			path: "/scouting/players/:id/edit",
		},
		{component: <HandleScoutingPlayerPage />, path: "/scouting/players/new"},
		{component: <StaffRolesPage />, path: "/settings/staff-roles"},
		{component: <StaffRolePage />, path: "/settings/staff-roles/:id"},
		{component: <HandleStaffRolePage />, path: "/settings/staff-roles/new"},
		{
			component: <HandleStaffRolePage edit />,
			path: "/settings/staff-roles/:id/edit",
		},
		{component: <StaffUnitsPage />, path: "/settings/staff-units"},
		{component: <StaffUnitPage />, path: "/settings/staff-units/:id"},
		{component: <HandleStaffUnitPage />, path: "/settings/staff-units/new"},
		{
			component: <HandleStaffUnitPage edit />,
			path: "/settings/staff-units/:id/edit",
		},
		{component: <SettingsPlayerRolesPage />, path: "/settings/player-roles"},
		{component: <SettingsComponentsPage />, path: "/settings/components"},
		{
			component: <SettingsPlayerRolePage />,
			path: "/settings/player-roles/:id",
		},
		{
			component: <HandleSettingsPlayerRolePage />,
			path: "/settings/player-roles/new",
		},
		{
			component: <HandleSettingsPlayerRolePage edit />,
			path: "/settings/player-roles/:id/edit",
		},
		{component: <SettingsModulesPage />, path: "/settings/modules"},
		{component: <SettingsModulePage />, path: "/settings/modules/:id"},
		{
			component: <HandleSettingsModulePage />,
			path: "/settings/modules/new",
		},
		{
			component: <HandleSettingsModulePage edit />,
			path: "/settings/modules/:id/edit",
		},
		{component: <UsersPage />, path: "/settings/users"},
		{component: <UserPage />, path: "/settings/users/:id"},
		{component: <HandleUserPage />, path: "/settings/users/new"},
		{component: <HandleUserPage edit />, path: "/settings/users/:id/edit"},
		{component: <UserRolesPage />, path: "/settings/user-roles"},
		{component: <UserRolePage />, path: "/settings/user-roles/:id"},
		{component: <HandleUserRolePage />, path: "/settings/user-roles/new"},
		{component: <ExercisesPage />, path: "/exercises"},
		{component: <ExercisePage />, path: "/exercises/:id"},
		{component: <HandleExercisePage />, path: "/exercises/new"},
		{
			component: <HandleExercisePage edit />,
			path: "/exercises/:id/edit",
		},
		{component: <PlayerProfilePage />, path: "/profile/:id"},
		{component: <ManagerFootballTeamsPage />, path: "/manager/teams"},
		{component: <ManagerFootballTeamPage />, path: "/manager/teams/:id"},
		{component: <ManagerHandleFootballTeamPage />, path: "/manager/teams/new"},
		{
			component: <ManagerHandleFootballTeamPage edit />,
			path: "/manager/teams/:id/edit",
		},
		{
			component: <HandleRosterPage source="manager" />,
			path: "/manager/teams/:id/players",
		},
		{
			component: <HandleRosterPage source="manager" type="staffs" />,
			path: "/manager/teams/:id/staffs",
		},
		{component: <ScoutingRostersPage />, path: "/development/rosters"},
		{
			component: <ScoutingRosterPage source="scouting" />,
			path: "/development/rosters/:id",
		},
		{
			component: <ManagerHandleFootballTeamPage source="scouting" />,
			path: "/development/rosters/new",
		},
		{
			component: <ManagerHandleFootballTeamPage source="scouting" edit />,
			path: "/development/rosters/:id/edit",
		},
		{
			component: <HandleRosterPage source="scouting" />,
			path: "/development/rosters/:id/players",
		},
		{
			component: <HandleRosterPage source="scouting" type="staffs" />,
			path: "/development/rosters/:id/staffs",
		},
		{component: <Navigate to="/ds/oggi" replace />, path: "/ds"},
		{component: <DsHomePage />, path: "/ds/oggi"},
		{component: <DsActivitiesPage />, path: "/ds/attivita"},
		{component: <DsTimelinePage />, path: "/ds/timeline"},
		{component: <DsTeamsPage />, path: "/ds/squadre"},
		{component: <DsMatchesPage />, path: "/ds/gare"},
		{component: <DsTeamManagerPage />, path: "/ds/team-manager"},
		{component: <DsPlayerPage />, path: "/ds/giocatore/:id"},
		{component: <DsTeamPage />, path: "/ds/squadra/:id"},
		{component: <DsMatchPage />, path: "/ds/gara/:id"},
		{component: <DsPerformancePage />, path: "/ds/performance"},
		{component: <DsMedicalPage />, path: "/ds/medica"},
		{component: <DsMarketPage />, path: "/ds/mercato"},
		{component: <DsAgentsPage />, path: "/ds/procuratori"},
		{component: <DsScoutingPage />, path: "/ds/scouting"},
		{component: <DsStaffPage />, path: "/ds/staff"},
		{component: <DsSecretariatPage />, path: "/ds/segreteria"},
		{component: <DsEconomyPage />, path: "/ds/economia"},
		{component: <DsFacilitiesPage />, path: "/ds/strutture"},
		{component: <DsCommercialPage />, path: "/ds/commerciale"},
		{component: <SecretariatPage />, path: "/secretariat"},
		{
			component: <MatchDayPage handleNotification={handleNotification} />,
			path: "/match-day",
		},
		{component: <ImportDataPage />, path: "/import-data"},
	];

	if (loading) {
		return <Loading />;
	}

	return (
		<>
			<Routes>
				<Route>
					<Route
						path="/login"
						element={<LoginPage handleNotification={handleNotification} />}
					/>
					<Route
						path="/public/valuation/:id"
						element={<PublicValuationPage />}
					/>
					<Route path="/public/player/:id" element={<PublicPlayerPage />} />
					{authRoutes.map((route, key) => {
						return (
							<Route
								key={key}
								path={route.path}
								exact
								element={
									<RequireAuth
										isLoggedIn={isLoggedIn}
										handleNotification={handleNotification}
									>
										{/^\/(ds|scouting|development|matches|manager\/teams)(\/|$)/.test(
											route.path,
										)
											? React.cloneElement(route.component, {
													key: dsContext + dsLocation.pathname,
												})
											: route.component}
									</RequireAuth>
								}
							/>
						);
					})}
					<Route
						path="*"
						element={
							<RequireAuth
								isLoggedIn={isLoggedIn}
								handleNotification={handleNotification}
							>
								<NotFoundPage />
							</RequireAuth>
						}
					/>
				</Route>
			</Routes>
			<Snackbar
				open={open}
				autoHideDuration={6000}
				anchorOrigin={{vertical: "bottom", horizontal: "right"}}
				onClose={handleClose}
			>
				<Alert severity={severity}>
					<div>{message}</div>
				</Alert>
			</Snackbar>
		</>
	);
}

export default App;
